import Scrollbar from '@admin/components/scrollbar'
import Attachment from './attachment'
import PropTypes from 'prop-types'
import React from 'react'

class Attachments extends React.Component {

  static propTypes = {
    email: PropTypes.object
  }

  render() {
    const { email } = this.props
    if(!(email.attachments?.length > 0)) return null
    return (
      <div className="maha-email-attachments">
        <Scrollbar { ...this._getScrollbar() }>
          { email.attachments.map((attachment, index) => (
            <Attachment { ...this._getAttachment(attachment) } key={`attachment_${index}`} />
          ))}
        </Scrollbar>
      </div>
    )
  }

  _getAttachment(attachment) {
    const { email } = this.props
    return {
      attachment,
      email
    }
  }

  _getScrollbar() {
    return {
      horizontal: true,
      vertical: false,
      hideScroll: true,
      className: 'maha-email-attachments-panel'
    }
  }

}

export default Attachments
